import './styles/tailwind.css';

import './controllers/export-data-form.ts';

const fieldset = document.getElementById('fieldset') as HTMLFieldSetElement;
fieldset.disabled = false;
